import {
  resolveInsurableGroupLabel,
  resolveInsurableGroupNotice,
} from '@/features/quotes/data/group-life/insurable-groups';
import { Tag } from '@noorden-insurtech/alba-design-system';

/**
 * Rótulo do grupo segurável de uma vida, com a marca "Análise" quando o grupo
 * exige intervenção da subscrição (Anexo IV). Usado nas tabelas de vidas da
 * cotação e da proposta.
 */
export function InsurableGroupLabel({ value }: { value: string }) {
  const label = resolveInsurableGroupLabel(value) || '—';
  const underAnalysis = resolveInsurableGroupNotice(value) === 'UNDER_ANALYSIS';

  return (
    <span className='inline-flex flex-wrap items-center gap-2'>
      <span>{label}</span>
      {underAnalysis && (
        <Tag.Root
          variant='outline'
          colorScheme='warning'
          size='sm'
          title='Grupo sujeito a análise da seguradora'
        >
          <Tag.Label>Análise</Tag.Label>
        </Tag.Root>
      )}
    </span>
  );
}
